enum HttpHeaders {
  allow = "Access-Control-Allow-Origin",
  apiKey = "X-API-Key",
  date = "X-Date",
  authorization = "Authorization",
}

export default HttpHeaders;
